import script from "./resource.center.vue?vue&type=script&setup=true&lang=js"
export * from "./resource.center.vue?vue&type=script&setup=true&lang=js"

import "./resource.center.vue?vue&type=style&index=0&id=0496b6ed&lang=less"

const __exports__ = script;

export default __exports__